const isEasingArray = (ease) => {
  return Array.isArray(ease) && typeof ease[0] !== "number";
};
export {
  isEasingArray
};
